function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { tns } from "tiny-slider/src/tiny-slider";

Sage.carousel = function () {
  var containerClass = '.sage-carousel__carousel';
  var arrowDisabledClass = 'sage-carousel__arrow--disabled';
  var indicatorActiveClass = 'sage-indicator--current';
  var arrowPrev;
  var arrowNext;
  var mySlider;
  var mySliderInfo;
  var options;
  var slidesLength;
  var looping;
  var startingSlide;
  var indicators;

  function init() {
    var slider = document.querySelector(containerClass);

    var slides = _toConsumableArray(slider.children);

    var slideContainer;
    slidesLength = slides.length;
    slides.forEach(function (slide, index) {
      slideContainer = document.createElement('div');
      slideContainer.classList.add('slide');
      slideContainer.setAttribute('aria-roledescription', 'slide');
      slideContainer.setAttribute('role', 'group');
      slideContainer.setAttribute('aria-label', "".concat(index + 1, " of ").concat(slidesLength));
      slideContainer.appendChild(slide);
      slider.appendChild(slideContainer);
    });
    options = JSON.parse(document.querySelector('.sage-carousel').getAttribute('data-js-carousel-options'));
    looping = !(options.loop !== undefined && !options.loop);
    startingSlide = options.startIndex || 0;
    mySlider = tns(_objectSpread(_objectSpread({}, options), {}, {
      container: containerClass,
      controls: false,
      nav: false
    }));
    mySlider.events.on('dragEnd', function () {
      goToSlide(mySlider.getInfo().index);
    });
    mySliderInfo = mySlider.getInfo();
    arrowPrev = document.querySelector('.sage-carousel__arrow--prev');
    arrowPrev.addEventListener('click', handlePrevArrowClick);
    arrowNext = document.querySelector('.sage-carousel__arrow--next');
    arrowNext.addEventListener('click', handleNextArrowClick);

    if (!looping) {
      var indicator;
      var indicatorNumber;
      var indicatorList = document.createElement('ul');
      var indicatorContainer = document.querySelector('.sage-carousel__indicator');
      indicatorList.classList.add('sage-indicator-list');
      indicatorList.setAttribute('aria-label', 'Showing 1 of ' + slidesLength);
      indicatorContainer.appendChild(indicatorList);

      for (var i = 0; i < slidesLength; i++) {
        indicator = document.createElement('li');
        indicator.classList.add('sage-indicator');
        indicatorNumber = document.createElement('span');
        indicatorNumber.classList.add('visually-hidden');
        indicatorNumber.innerHTML = i + 1;
        indicator.appendChild(indicatorNumber);
        document.querySelector('.sage-indicator-list').appendChild(indicator);
      }

      ;
    }

    indicators = document.querySelectorAll('.sage-indicator');
    goToSlide(startingSlide);
  }

  function goToSlide(num) {
    if (!looping) {
      if (num === 0) arrowPrev.classList.add(arrowDisabledClass);else arrowPrev.classList.remove(arrowDisabledClass);
      if (num === slidesLength - 1) arrowNext.classList.add(arrowDisabledClass);else arrowNext.classList.remove(arrowDisabledClass);
      indicators.forEach(function (indicator) {
        indicator.classList.remove(indicatorActiveClass);
      });
      indicators[num].classList.add(indicatorActiveClass);
      mySlider.goTo(num);
    }

    ;
  }

  function handlePrevArrowClick() {
    mySliderInfo = mySlider.getInfo();

    if (!looping) {
      if (mySliderInfo.index !== 0) goToSlide(mySliderInfo.index - 1);
    } else {
      mySlider.goTo('prev');
    }
  }

  function handleNextArrowClick() {
    mySliderInfo = mySlider.getInfo();

    if (!looping) {
      if (mySliderInfo.index !== slidesLength - 1) goToSlide(mySliderInfo.index + 1);
    } else {
      mySlider.goTo('next');
    }
  }

  return {
    init: init
  };
}();